import { React } from 'react';
import { TbSortAscendingSmallBig } from 'react-icons/tb';

const EmailSorting = ({
  emailSorting = {},
  setEmailSorting,
  emailfilter,
  setEmailFilter,
}) => {
  const items = [
    { name: 'Priority', sortingKey: 'priority_desc', value: true },
  ];

  const handleFilterChange = (filters) => {
    setEmailFilter((prevFilter) => ({
      ...prevFilter,
      ...filters,
    }));
  };

  const handleSortingChange = (item) => {
    if (item.name === 'Priority') {
      if (emailSorting === 'priority_desc') {
        setEmailSorting('priority_asc');
        handleFilterChange({ sort_field: 'priority', sort_order: 'asc' });
      } else if (emailSorting === 'priority_asc') {
        setEmailSorting(null);
        clearSortingFilters();
      } else {
        setEmailSorting('priority_desc');
        handleFilterChange({ sort_field: 'priority', sort_order: 'desc' });
      }
    } else {
      setEmailSorting(item.sortingKey);
    }
  };

  const clearSortingFilters = () => {
    setEmailFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      delete newFilter['sort_field'];
      delete newFilter['sort_order'];
      return newFilter;
    });
  };

  return (
    <div className="flex flex-col gap-2 text-xs">
      {items.map((item, index) => (
        // eslint-disable-next-line
        <div
          key={index}
          className={`flex cursor-pointer items-center justify-between gap-4 rounded-lg px-2 py-1 transition-all duration-200 sm:w-52 
            ${emailSorting?.includes('priority') ? 'bg-primary-gradient text-white' : 'text-white'}`}
          onClick={() => handleSortingChange(item)}
        >
          <span className="text-sm font-semibold">{item.name}</span>
          {emailSorting === 'priority_desc' && (
            <TbSortAscendingSmallBig className="rotate-180 transform text-lg" />
          )}
          {emailSorting === 'priority_asc' && (
            <TbSortAscendingSmallBig className="text-lg" />
          )}
        </div>
      ))}
    </div>
  );
};

export default EmailSorting;
